import { render, staticRenderFns } from "./OrdersRemoved.vue?vue&type=template&id=fc297354&"
import script from "./OrdersRemoved.vue?vue&type=script&lang=js&"
export * from "./OrdersRemoved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports